// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Language list */
.oQhb8mhFJBtNoBIbOCOR {
  display: grid;
  gap: 45px 27px;
  justify-content: center;
  padding: 8px;
  grid-template-columns: repeat(auto-fill, 88.2px);
}
.hppwUI71ry3gU_t7YsaP {
  justify-content: space-between;
  display: flex;
  cursor: pointer;
  width: 88.2px;
  height: 54.1px;
  text-align: start;
  align-items: center;
}
.MXTFJK5qpOa3AFSWRA7v {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 38px;
  width: 58px;
  max-width: 58px;
}
@media (min-width: 460px) {
  .MXTFJK5qpOa3AFSWRA7v {
    height: 34.2px;
    width: 52.2px;
    max-width: 52.2px;
  }
}
.WGD90uAOEharYWVEgawn {
  height: 38px;
  width: 58px;
  max-width: 58px;
}
@media (min-width: 460px) {
  .WGD90uAOEharYWVEgawn {
    height: 34.2px;
    width: 52.2px;
    max-width: 52.2px;
  }
}
.QYktLp7eq_nejIHTRfLu {
  color: white;
  font-size: 14.4px;
  font-weight: 400;
  display: flex;
  justify-content: start;
  text-align: start;
  align-items: center;
  line-height: 14.4px;
  margin-top: 14.4px;
  width: 100%;
}
.bhA6B_afzse4Tr4Neb1_ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  min-height: 20px;
  min-width: 20px;
  border: 2px solid white;
  background-color: black;
  border-radius: 50%;
  text-align: center;
}
/* Selected state for language radio */
.Xe4Xqjr0IG61dJTOLN77 {
  border: 2px solid var(--piliot-green);
}
.Xe4Xqjr0IG61dJTOLN77::after {
  content: '';
  background: var(--piliot-green, #3CFF00);
  border-radius: 50%;
  border: 2px solid black;
  box-sizing: border-box;
  width: 100%;
  height: 16px;
  cursor: pointer;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/features/settings/components/LanguageList/LanguageList.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Language list */\n.languageList {\n  display: grid;\n  gap: 45px 27px;\n  justify-content: center;\n  padding: 8px;\n  grid-template-columns: repeat(auto-fill, 88.2px);\n}\n.languageOption {\n  justify-content: space-between;\n  display: flex;\n  cursor: pointer;\n  width: 88.2px;\n  height: 54.1px;\n  text-align: start;\n  align-items: center;\n}\n.languageInfo {\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 38px;\n  width: 58px;\n  max-width: 58px;\n}\n@media (min-width: 460px) {\n  .languageInfo {\n    height: 34.2px;\n    width: 52.2px;\n    max-width: 52.2px;\n  }\n}\n.flagImage {\n  height: 38px;\n  width: 58px;\n  max-width: 58px;\n}\n@media (min-width: 460px) {\n  .flagImage {\n    height: 34.2px;\n    width: 52.2px;\n    max-width: 52.2px;\n  }\n}\n.languageName {\n  color: white;\n  font-size: 14.4px;\n  font-weight: 400;\n  display: flex;\n  justify-content: start;\n  text-align: start;\n  align-items: center;\n  line-height: 14.4px;\n  margin-top: 14.4px;\n  width: 100%;\n}\n.languageRadio {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  min-height: 20px;\n  min-width: 20px;\n  border: 2px solid white;\n  background-color: black;\n  border-radius: 50%;\n  text-align: center;\n}\n/* Selected state for language radio */\n.languageRadioSelected {\n  border: 2px solid var(--piliot-green);\n}\n.languageRadioSelected::after {\n  content: '';\n  background: var(--piliot-green, #3CFF00);\n  border-radius: 50%;\n  border: 2px solid black;\n  box-sizing: border-box;\n  width: 100%;\n  height: 16px;\n  cursor: pointer;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"languageList": `oQhb8mhFJBtNoBIbOCOR`,
	"languageOption": `hppwUI71ry3gU_t7YsaP`,
	"languageInfo": `MXTFJK5qpOa3AFSWRA7v`,
	"flagImage": `WGD90uAOEharYWVEgawn`,
	"languageName": `QYktLp7eq_nejIHTRfLu`,
	"languageRadio": `bhA6B_afzse4Tr4Neb1_`,
	"languageRadioSelected": `Xe4Xqjr0IG61dJTOLN77`
};
export default ___CSS_LOADER_EXPORT___;
